import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.scss';
 
export default function MissingDetailIcon(props) {
    return (
        <div
            className={styles.MissingDetailIcon}
        >
            <FontAwesomeIcon icon={faTriangleExclamation} style={{color: '#CC3333', paddingLeft: '10px', fontSize: '18px'}} />
        </div>
    );
}